import { SimplifiedBasketItem } from "@/utils/basket/types";
import { TickOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import styles from "./ProductBasketItems.module.scss";

type BasketConfirmationProps = {
  basket: SimplifiedBasketItem[];
};

export const ProductBasketItems = ({ basket }: BasketConfirmationProps) => {
  return (
    <>
      <div aria-live="polite" data-testid="basket:confirmation">
        <h2 data-testid="basket:confirmation:heading">Added to your basket:</h2>
        <ul className={styles.list}>
          {basket.map(({ id, title, quantity }) => (
            <li key={id} className={styles.listItem}>
              <TickOutlined />
              <div className={styles.text}>
                <span data-testid="basket:confirmation:qty">{quantity}</span>
                <span> x </span>
                <span data-testid="basket:confirmation:title"> {title}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <PrimaryButton
        tag="a"
        target="_top"
        href="/basket"
        data-testid="basket:confirmation:gtb"
      >
        Go to your basket
      </PrimaryButton>
    </>
  );
};
